import type { AdminListItem } from '@immo/api-contract';

// The admin api-keys read shapes carry the issuing / revoking operator as a bare
// admin id (`issuedBy` / `revokedByAdmin`). The admin lives in a different module,
// so there is no server-side name join — the boundary is deliberate. The list and
// detail loaders resolve the name client-side against the admin list, via this map.

export type OperatorNameMap = ReadonlyMap<string, string>;

export function buildOperatorNameMap(admins: ReadonlyArray<AdminListItem>): OperatorNameMap {
  return new Map(admins.map((admin) => [admin.id, admin.fullName]));
}

// Resolve a (non-null) operator id to a display name. An id absent from the map
// (a deactivated + pruned admin, or an edge case) falls back to the generic label
// — never the raw uuid, never a crash.
export function operatorName(id: string, map: OperatorNameMap, fallback: string): string {
  return map.get(id) ?? fallback;
}
